import { render, staticRenderFns } from "./TabletopAudioSoundPadDialog.vue?vue&type=template&id=7b79e831&scoped=true&lang=pug&"
import script from "./TabletopAudioSoundPadDialog.vue?vue&type=script&lang=js&"
export * from "./TabletopAudioSoundPadDialog.vue?vue&type=script&lang=js&"
import style0 from "./TabletopAudioSoundPadDialog.vue?vue&type=style&index=0&id=7b79e831&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79e831",
  null
  
)

component.options.__file = "TabletopAudioSoundPadDialog.vue"
export default component.exports